module.exports = __webpack_public_path__ + "img/savingsblur.47b45d79.jpg";